
  import { Component, Prop, Vue ,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import UploadImg from '@/components/upload-img.vue';
	import draggable from 'vuedraggable'
	import ChoosePages from '@/components/choosepages/choosepages.vue';
  import {
    imgHost
  } from "@/utils/config"
  @Component({  
    name: '',
    components: {
      PageFooter,
      UploadImg,
      draggable,
      ChoosePages
    }
  })

  export default class ProductList extends Vue {
    private imgHost = imgHost
    private imglist:any = this.editmsg.imglist
    private token:any = {}
    private show = false
    private momentsel = -1
    private changeindex = -1
    private choosemsg:any = {}

    @Inject() editinfo:any
    get editmsg(){
      return this.editinfo.msg
    }

    private mounted () {

    }

    private del(i){
      this.imglist.splice(i,1)
      this.editinfo.msg.imglist = this.imglist
    }
    private clear(i){
      this.imglist = this.imglist.map((v,x)=>{
        if(i==x){
          v.Id = 0
          v.pageurl = ''
          v.PageUrl = ''
          v.PageName = ''
          v.label = ''
          v.pagetype = ''
          v.pagetypelabel = ''
          v.subdivideType = ''
          v.subdivideTypeValue = '',
          v.CouponNo = ''
        }
        return v
      })
      // console.log(this.imglist)
    }
    private getdata(e){
      console.log(e)
      this.show = false
      for(let key in e){
        this.imglist[this.momentsel][key] = e[key]
      }
      
    }
    private getImageInfo(url){
      return new Promise((resolve, reject)=>{
        let imageUrl = this.imgHost + url;
        let image = new Image();
        image.onload = function(){
          resolve({
            width: image.width,
            height: image.height
          });
        }
        image.onerror = function(){
          resolve({
            width: 0,
            height: 0
          });
        }
        image.src = imageUrl;
      })
    }
    private async uploadSuc(list){
      let imageInfo:any = await this.getImageInfo(list[0]);
      if(this.changeindex>-1){
        this.imglist[this.changeindex].url = list[0];
        this.imglist[this.changeindex].width = imageInfo.width;
        this.imglist[this.changeindex].height = imageInfo.height;
        this.changeindex = -1
        return 
      }
      if(this.imglist&&this.imglist.length>=10){
        this.$message.error('最多上传10张图片')
        return
      }
      this.imglist.push({
        url:list[0],
        width: imageInfo.width,
        height: imageInfo.height,
        pagetype:0,
        pagetypelabel:'',
        Id:0,
        name:'',
        startTime:'',
        endTime:'',
        CouponNo: ''
      })
    }
    private chooseimgagain(e){
      (this as any).$refs.uploadimg.$refs.upload.click()
      this.changeindex = e
    }
    private choosepage(i){
      this.momentsel = i
      this.choosemsg = this.imglist[i]
      // console.log(this.choosemsg)
      this.show = true
    }
    private emitchange(e){
      this.editinfo.msg.imglist = this.imglist
    }
  }
